import { Box, SxProps, Theme, Typography, useTheme } from '@mui/material';
import { FC } from 'react';

interface Props {
  text: string;
  sx?: SxProps<Theme>;
}

const MenuHeading: FC<Props> = ({ text, sx }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        px: theme.spacing(2),
        py: theme.spacing(1),
        ...sx,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: theme.palette.text.disabled,
          textTransform: 'uppercase',
          fontWeight: 700,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default MenuHeading;
